import React from 'react';
import {Segment, Grid, Form, Divider} from 'semantic-ui-react';
import _ from 'lodash';
import {
  PAYMENT_PATH_ROOT,
  ANNUAL_SALARY,
  ANNUAL_BENEFITS,
  MODES,
} from 'common/requestDetails/constants.js';
import EmployeePayment from 'go/components/modules/requestDetails/v3/items/paymentRequest/staffingBundled/EmployeePayment';
import {
  sortAndPartitionEmployeesByStartDate,
  safeAdd,
  showDollarAmountWithDollar,
} from 'common/utils';
import {Alert} from 'componentLibrary';
import {calculateFederalTotalForPosition} from 'common/requestDetails/utils';
import InactiveAccordion from 'go/components/modules/requestDetails/v3/renderers/InactiveAccordion';
import ActiveAccordion from 'go/components/modules/requestDetails/v3/renderers/ActiveAccordion';

export default class PositionPayment extends React.Component {
  state = {
    isActive: false,
  };

  handleExpand = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  handleBlur = (rosterId, fieldName) => {
    this.props.handleBlur(rosterId + '.' + fieldName);
  };

  handleChange = (rosterId, name, value) => {
    const {
      item,
      employees,
      positionId,
      positionDisplayId,
      editable,
      staffingStreamType,
      periodOfPerformance,
      validationErrors,
      validationDirtyMap,
      turnOffvalidationLimits,
      itemConfig,
    } = this.props;

    const paymentSection = _.cloneDeep(
      _.get(item, [...PAYMENT_PATH_ROOT, positionId]) || {
        quantity: 1,
        price: 0,
        employees: {},
      }
    );
    _.set(paymentSection, ['employees', rosterId, name], value);

    const calculatedTotal = _.reduce(
      _.map(paymentSection.employees, (e) =>
        safeAdd(_.get(e, ANNUAL_BENEFITS), _.get(e, ANNUAL_SALARY))
      ),
      (total, item) => {
        return safeAdd(total, item);
      },
      0
    );
    _.set(paymentSection, 'price', calculatedTotal);

    // need to work with a new item that now contains the changed values

    let newItem = _.cloneDeep(item);
    _.set(newItem, [...PAYMENT_PATH_ROOT, positionId], paymentSection);

    // need to update the calcfedshare
    let updatedFedShare = calculateFederalTotalForPosition({
      employees,
      item: newItem,
      positionId,
      endDate: _.get(this.props, 'paymentPeriod.endDate'),
      approvedPositionPayments: _.get(this.props, 'approvedPositionPayments', []),
      grantBudgetShareFedRate: _.get(this.props, 'grantBudgetShareFedRate', []),
      periodOfPerformance,
      turnOffvalidationLimits,
    });

    _.set(
      paymentSection,
      ['fedResourcesRequested'],
      updatedFedShare.fedResourcesRequested
    );
    _.set(
      paymentSection,
      ['fedResourcesRequestedUnrounded'],
      updatedFedShare.fedResourcesRequestedUnrounded
        ? updatedFedShare.fedResourcesRequested
        : undefined
    );

    _.set(
      paymentSection,
      ['requestedIsLessThanRemaining'],
      updatedFedShare.requestedIsLessThanRemaining
    );
    _.set(paymentSection, ['isFedShare100Percent'], updatedFedShare.isFedShare100Percent);

    return this.props.handleChange(paymentSection);
  };

  // todo, filter out people not in the date range

  renderInternal = (calcFedShare) => {
    const {
      item,
      employees,
      positionId,
      positionDisplayId,
      editable,
      staffingStreamType,
      periodOfPerformance,
      validationErrors,
      validationDirtyMap,
      turnOffvalidationLimits,
      itemConfig,
    } = this.props;
    const staffingFOConfig = _.find(
      _.get(this.props, 'fundingOpportunityStreams'),
      (stream) => stream.fundingStreamType === staffingStreamType
    );
    const [activeEmployees, inactiveEmployees] = sortAndPartitionEmployeesByStartDate(
      employees
    );

    const showPositionCostLimit =
      calcFedShare.requestedIsLessThanRemaining != undefined &&
      calcFedShare.isFedShare100Percent != undefined &&
      !calcFedShare.requestedIsLessThanRemaining &&
      !calcFedShare.isFedShare100Percent;
    const showFederalResourceLimit =
      calcFedShare.requestedIsLessThanRemaining != undefined &&
      calcFedShare.isFedShare100Percent != undefined &&
      !calcFedShare.requestedIsLessThanRemaining &&
      calcFedShare.isFedShare100Percent;

    const paymentSection = _.get(item, [...PAYMENT_PATH_ROOT, positionId]);
    const showDivider = _.size(activeEmployees) > 0 && _.size(inactiveEmployees) > 0;

    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={13}>
              {_.map(activeEmployees, (emp, index) => (
                <React.Fragment key={positionId}>
                  <EmployeePayment
                    key={positionId + 1}
                    employee={emp}
                    editable={editable}
                    employeePayment={_.get(
                      paymentSection,
                      ['employees', emp.rosterId],
                      {}
                    )}
                    positionId={positionId}
                    labels={_.get(staffingFOConfig, 'labels')}
                    validationErrors={validationErrors}
                    validationDirtyMap={validationDirtyMap}
                    handleChange={(name, value) => {
                      this.handleChange(emp.rosterId, name, value);
                    }}
                    handleBlur={(fieldName) => this.handleBlur(emp.rosterId, fieldName)}
                    itemConfig={itemConfig}
                  />
                  {index + 1 < _.size(activeEmployees) && <Divider />}
                </React.Fragment>
              ))}
              {showDivider && <Divider />}
              {_.map(inactiveEmployees, (emp, index) => (
                <React.Fragment key={positionId}>
                  <EmployeePayment
                    employee={emp}
                    editable={editable}
                    employeePayment={_.get(
                      paymentSection,
                      ['employees', emp.rosterId],
                      {}
                    )}
                    positionId={positionId}
                    validationErrors={validationErrors}
                    validationDirtyMap={validationDirtyMap}
                    labels={_.get(staffingFOConfig, 'labels')}
                    handleChange={(name, value) =>
                      this.handleChange(emp.rosterId, name, value)
                    }
                    handleBlur={(fieldName) => this.handleBlur(emp.rosterId, fieldName)}
                    itemConfig={itemConfig}
                  />
                  {index + 1 < _.size(inactiveEmployees) && <Divider />}
                </React.Fragment>
              ))}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="right">
              <strong>
                Federal resources requested for position {safeAdd(positionDisplayId, 1)}:{' '}
                {showDollarAmountWithDollar(
                  calcFedShare.fedResourcesRequested ||
                    _.round(calcFedShare.fedResourcesRequestedUnrounded, 2) ||
                    0.0
                )}
              </strong>
            </Grid.Column>
          </Grid.Row>
          {showPositionCostLimit && !turnOffvalidationLimits ? (
            <Grid.Row>
              <Grid.Column>
                <Alert
                  size="mini"
                  header="Position cost limit"
                  type="info"
                  dismissable={false}
                >
                  The federal resources requested for this position may be less than
                  expected because this position has reached the position cost limit for
                  this year.
                </Alert>
              </Grid.Column>
            </Grid.Row>
          ) : (
            ''
          )}
          {showFederalResourceLimit ? (
            <Grid.Row>
              <Grid.Column>
                <Alert
                  size="mini"
                  header="Federal resources limit"
                  type="info"
                  dismissable={false}
                >
                  The federal resources requested for this position may be less than
                  expected because this position has reached the federal resources limit
                  for this year.
                </Alert>
              </Grid.Column>
            </Grid.Row>
          ) : (
            ''
          )}
        </Grid>
      </Form>
    );
  };

  render() {
    const {
      item,
      employees,
      positionId,
      positionDisplayId,
      editable,
      periodOfPerformance,
      turnOffvalidationLimits,
      validationErrors,
      tier,
    } = this.props;
    const positionError = _.get(validationErrors, `error.0.error.${positionId}`);
    let isValid = positionError ? positionError.isValid : true;
    const calcFedShare = editable
      ? calculateFederalTotalForPosition({
          employees,
          item,
          positionId,
          endDate: _.get(this.props, 'paymentPeriod.endDate'),
          approvedPositionPayments: _.get(this.props, 'approvedPositionPayments', []),
          grantBudgetShareFedRate: _.get(this.props, 'grantBudgetShareFedRate', []),
          periodOfPerformance,
          turnOffvalidationLimits,
        })
      : {
          //transition - if legacy use fedResourcesUnrounded value.
          fedResourcesRequested: _.get(
            item,
            ['additionalInformation', 'payment', positionId, 'fedResourcesRequested'],
            _.get(
              item,
              [
                'additionalInformation',
                'payment',
                positionId,
                'fedResourcesRequestedUnrounded',
              ],
              0
            )
          ),
          requestedIsLessThanRemaining: turnOffvalidationLimits
            ? false
            : _.get(item, [
                'additionalInformation',
                'payment',
                positionId,
                'requestedIsLessThanRemaining',
              ]),
          isFedShare100Percent: turnOffvalidationLimits
            ? false
            : _.get(item, [
                'additionalInformation',
                'payment',
                positionId,
                'isFedShare100Percent',
              ]),
        };

    if (this.state.isActive) {
      return (
        <ActiveAccordion
          tier={tier}
          isNarrative={false}
          handleToggle={this.handleExpand}
          total={
            calcFedShare.fedResourcesRequested ||
            _.round(calcFedShare.fedResourcesRequestedUnrounded, 2) ||
            0.0
          }
          headerTitle={`Position ${positionDisplayId + 1}`}
          activityName={`Position ${positionDisplayId + 1}`}
          isValid={isValid}
          validationErrors={positionError}
          activityKey={'position-details'}
          editable={editable}
          editMode={true}
          newlyCreated={false}
          deletable={false}
          ineligible={false}
          deferred={false}
          mode={MODES.PAYMENT_REQUEST}
        >
          {this.renderInternal(calcFedShare)}
        </ActiveAccordion>
      );
    } else {
      return (
        <InactiveAccordion
          tier={tier}
          handleToggle={this.handleExpand}
          total={
            calcFedShare.fedResourcesRequested ||
            _.round(calcFedShare.fedResourcesRequestedUnrounded, 2) ||
            0.0
          }
          headerTitle={`Position ${positionDisplayId + 1}`}
          activityName={`Position ${positionDisplayId + 1}`}
          isValid={isValid}
          editable={editable}
          ineligible={false}
          mode={MODES.PAYMENT_REQUEST}
        />
      );
    }
  }
}
